import { createSelector } from "reselect";
import { get, sortBy } from "lodash";
import { getPageContent } from "./base";

// eslint-disable-next-line import/prefer-default-export
export const getMacros = createSelector([getPageContent], pageContent => {
  return sortBy(get(pageContent, "macros", []), macro => macro.name);
});
